export enum PaymentsTypes {
  INCOME = 125,
  EXPENSE = 126,
}
